import { apiLocal } from '@/services/Api'

function parse (objId, end) {
  return apiLocal().get(`parse/parsemh?objId=${objId}&end=${end}`)
}

function parseByUserIdAndStartAt (userId, startAt, end) {
  return apiLocal().get(`parse/parsemhat?userId=${userId}&startAt=${startAt}&end=${end}`)
}

export {
  parse,
  parseByUserIdAndStartAt
}



// WEBPACK FOOTER //
// ./src/services/MhService.js